module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABgAAAAYCAYAAADgdz34AAAAAXNSR0IArs4c6QAAAARzQklUCAgICHwIZIgAAADVSURBVEiJ7ZS9DYMwEEbfIYbICEh2kxFSMDUFI6QxEiMwRPClMRG/4iwFpcl12P7eO2wD/OukZP4QQniKSAnUzrkhB9R13Q1oVPXlvb9P48XCJlKqqlfVNgXMcFVtVdWnBj9VrNbWQA9UVskEB6qUrRdNnwVE5HG0XZa1G4E1aG1kV3AGyHnLQ8ERCMAKPxXsSdKwCW4S7EiwwmF7Tb9ev92iSw/50mt66Yd26a8iB27NrK9pkwMHcM4N6fD7lG3m8wtBjHEUkWCFryUiEmKMozX3LwDex6L6FHRXLvwAAAAASUVORK5CYII="


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/aboutKangLin/close.png
// module id = GXHI
// module chunks = 18